
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class PayorService {

    getPayorId() {
        let payorId = ''
        try {
            payorId = sessionStorage.getItem('payorId');
        } catch {
            payorId = '';
        }
        return payorId;
    }

    getPayorCount() {
        let payorCount = 0
        try {
            payorCount = Number(sessionStorage.getItem('payorCount'));
        } catch {
            payorCount = 0
        }
        return payorCount;
    }
}